// const evaluateCondition = (val1, condition, val2) => {
//   if (val1 === undefined || val1 === null) val1 = "";

//   const v1 = typeof val1 === "string" ? val1 : String(val1);
//   const v2 = typeof val2 === "string" ? val2 : String(val2);

//   switch (condition) {
//     case "empty":
//       return v1.trim() === "";

//     case "not empty":
//       return v1.trim() !== "";

//     case "==":
//     case "=":
//     case "equals":
//       return v1 == v2;

//     case "!=":
//     case "<>":
//     case "does not equal":
//       return String(val1) != String(val2);

//     case "contains":
//       return v1.includes(v2);

//     case "does not contain":
//     case "notcontains":
//       return !v1.includes(v2);

//     case ">":
//     case "greater than":
//       return Number(v1) > Number(v2);

//     case "<":
//     case "less than":
//       return Number(v1) < Number(v2);

//     case ">=":
//     case "greater than or equal to":
//       return Number(v1) >= Number(v2);

//     case "<=":
//     case "less than or equal to":
//       return Number(v1) <= Number(v2);

//     default:
//       return false;
//   }
// };
const evaluateCondition = (val1, condition, val2) => {
  if (val1 === undefined || val1 === null) val1 = "";

  switch (condition) {
    case "empty":
      return String(val1).trim() === "";

    case "notempty":
    case "not empty":
      return String(val1).trim() !== "";

    case "=":
    case "==":
    case "equals":
      return String(val1) == String(val2);

    case "!=":
    case "<>":
    case "does not equal":
      return String(val1) != String(val2);

    case "contains":
      return String(val1).includes(String(val2));

    case "notcontains":
    case "does not contain":
      return !String(val1).includes(String(val2));

    case "anyof":
      return Array.isArray(val2)
        ? val2.map(String).includes(String(val1))
        : false;

    case "noneof":
      return Array.isArray(val2)
        ? !val2.map(String).includes(String(val1))
        : false;

    case ">":
    case "greater than":
      return val1 > val2;

    case "<":
    case "less than":
      return val1 < val2;

    case ">=":
    case "greater than or equal to":
      return val1 >= val2;

    case "<=":
    case "less than or equal to":
      return val1 <= val2;

    default:
      return false;
  }
};

const findFieldRecursive = (fields, fieldName) => {
  if (!Array.isArray(fields)) return null;

  for (const field of fields) {
    if (field.name === fieldName) return field;

    if (field.type === "panel" && Array.isArray(field.elements)) {
      const found = findFieldRecursive(field.elements, fieldName);
      if (found) return found;
    }
  }

  return null;
};

// const parseSingleCondition = (expr) => {
//   const normalized = expr.trim();

//   // empty / not empty
//   let m = normalized.match(/\{(.+?)\}\s*(empty|not empty)/i);
//   if (m) {
//     return {
//       fieldName: m[1].trim(),
//       operator: m[2].toLowerCase(),
//       value: null,
//     };
//   }

//   // other operators
//   m = normalized.match(
//     /\{(.+?)\}\s*(==|=|!=|contains|does not contain|greater than or equal to|less than or equal to|greater than|less than|equals|does not equal)\s*'(.+?)'/i,
//   );

//   if (!m) return null;

//   return {
//     fieldName: m[1].trim(),
//     operator: m[2].toLowerCase(),
//     value: m[3],
//   };
// };
const parseSingleCondition = (expr) => {
  const normalized = expr.trim();

  // empty / not empty
  let m = normalized.match(/\{(.+?)\}\s*(empty|not empty|notempty)/i);
  if (m) {
    return {
      fieldName: m[1].trim(),
      operator: m[2].toLowerCase(),
      value: null,
    };
  }

  // anyof / noneof [a, b, c]
  m = normalized.match(/\{(.+?)\}\s*(anyof|noneof)\s*\[([^\]]+)\]/i);
  if (m) {
    return {
      fieldName: m[1].trim(),
      operator: m[2].toLowerCase(), // anyof | noneof
      value: m[3].split(",").map((v) => v.trim().replace(/^'|'$/g, "")),
    };
  }

  // quoted string OR number
  m = normalized.match(
    /\{(.+?)\}\s*(==|=|!=|<>|<|>|>=|<=|contains|notcontains|does not contain|greater than or equal to|less than or equal to|greater than|less than|equals|does not equal)\s*(?:'(.+?)'|(\d+(?:\.\d+)?))/i,
  );

  if (!m) return null;

  return {
    fieldName: m[1].trim(),
    operator: m[2].toLowerCase(),
    value: m[3] ?? m[4],
  };
};

//   const normalized = ruleString.replace(/\s+/g, " ").trim();
//   console.log("Parsing rule expression:", normalized);

//   let operator = null;
//   let parts = [];

//   if (normalized.includes(" and ")) {
//     operator = "and";
//     parts = normalized.split(" and ");
//   } else if (normalized.includes(" or ")) {
//     operator = "or";
//     parts = normalized.split(" or ");
//   } else {
//     parts = [normalized];
//   }

//   return {
//     operator, // null | "and" | "or"
//     conditions: parts.map(parseSingleCondition).filter(Boolean),
//   };
// };
const parseRuleExpression = (ruleString) => {
  const normalized = ruleString.replace(/\s+/g, " ").trim();

  // OR groups (lowest priority)
  const orGroups = normalized.split(" or ");

  return {
    operator: "or",
    groups: orGroups.map((group) => {
      // AND inside each OR group
      const andParts = group.split(" and ");
      return andParts.map(parseSingleCondition).filter(Boolean);
    }),
  };
};

export const evaluateRule = (allValues, currentFields, ruleString) => {
  if (!ruleString) return true;

  const parsed = parseRuleExpression(ruleString);
  if (!parsed?.groups?.length) return true;

  // OR logic
  return parsed.groups.some((andGroup) => {
    // AND logic
    return andGroup.every((cond) => {
      const targetField = findFieldRecursive(currentFields, cond.fieldName);
      if (!targetField) return false;

      const key = `${targetField.name}_${targetField.receivedId}`;
      const actualValue = allValues?.[key];

      return evaluateCondition(actualValue, cond.operator, cond.value);
    });
  });
};

export const applyForceDisabled = (fields, isDisabled) => {
  if (!Array.isArray(fields)) return fields;

  return fields.map((field) => {
    const updatedField = {
      ...field,
      forceDisabled: isDisabled,
    };

    // If panel → apply recursively to children
    if (field.type === "panel" && Array.isArray(field.elements)) {
      updatedField.elements = applyForceDisabled(field.elements, isDisabled);
    }

    return updatedField;
  });
};

// Old code for rendering side by side panel questions
// if (field.type === "panel" && Array.isArray(field.elements)) {
//   return (
//     <Grid2
//       key={index}
//       container
//       spacing={2}
//       sx={{ width: "70%", mb: 3, margin: "auto" }}
//     >
//       {field.elements.map((childField, childIndex) => (
//         <Grid2
//           key={`${childField.id}_${childField.receivedId}`}
//           size={{ xs: 12, sm: 6 }} // side-by-side layout
//         >
//           <FieldRenderer
//             field={childField}
//             index={childIndex}
//             control={control}
//             register={register}
//             errors={errors}
//             componentMap={componentMap}
//             currentFields={field.elements} // important
//           />
//         </Grid2>
//       ))}
//     </Grid2>
//   );
// }

export function findTitleByReceivedId(surveyJson, searchId) {
  if (!surveyJson || !searchId) return null;

  function traverse(node) {
    if (!node || typeof node !== "object") return null;

    // Match condition
    if (node.receivedId === searchId) {
      return node.title || node?.name || null;
    }

    // Recurse into nested elements
    if (Array.isArray(node.elements)) {
      for (const child of node.elements) {
        const found = traverse(child);
        if (found) return found;
      }
    }

    return null;
  }

  // Start from pages
  if (Array.isArray(surveyJson.pages)) {
    for (const page of surveyJson.pages) {
      const found = traverse(page);
      if (found) return found;
    }
  }

  return null; // not found
}

export function findNode(surveyJson, searchId) {
  if (!surveyJson || !searchId) return null;

  function traverse(node) {
    if (!node || typeof node !== "object") return null;

    // Match condition
    if (node.receivedId === searchId) {
      return node || null;
    }

    // Recurse into nested elements
    if (Array.isArray(node.elements)) {
      for (const child of node.elements) {
        const found = traverse(child);
        if (found) return found;
      }
    }

    return null;
  }

  // Start from pages
  if (Array.isArray(surveyJson.pages)) {
    for (const page of surveyJson.pages) {
      const found = traverse(page);
      if (found) return found;
    }
  }

  return null; // not found
}

export const normalizeFormat = (formatFromApi) => {
  if (!formatFromApi) return "DD-MM-YYYY";

  return formatFromApi.replace(/dd/g, "DD").replace(/yyyy/g, "YYYY");
};

export const checkGenderChoicesExist = (choices) => {
  if (Array.isArray(choices)) {
    return choices.some(
      (choice) =>
        choice?.value?.toLowerCase() === "male" ||
        choice?.value?.toLowerCase() === "female" ||
        choice?.value?.toLowerCase() === "other",
    );
  } else return false;
};

export const stripHtml = (html) => {
  if (!html) return "";

  const temp = document.createElement("div");
  temp.innerHTML = html;

  return temp.textContent?.replace(/\u00A0/g, " ").trim() || "";
};

//for getting dynamic calendar view
export const getPickerViews = (format) => {
  if (!format.includes("DD")) {
    if (format.includes("MMM") && format.includes("YYYY")) {
      return {
        views: ["year", "month"],
        openTo: "month",
      };
    }

    if (format.includes("YYYY")) {
      return {
        views: ["year"],
        openTo: "year",
      };
    }
  }

  return {
    views: ["year", "month", "day"],
    openTo: "day",
  };
};
